/**
 * Pricing Table — inspector.
 *
 * Structure only. Colour, spacing, borders and type come from core's own
 * panels via block supports, which is the whole reason the block declares them
 * rather than re-implementing a colour picker per element the way the block
 * this replaces did.
 *
 * The options themselves are edited on the chooser block, where an author is
 * already looking when they want to change them. The table still stores them —
 * the price block has to be handed the same list — but storing and editing do
 * not have to happen in the same panel.
 */
import { __ } from '@wordpress/i18n';
import { PanelBody, SelectControl } from '@wordpress/components';

import { planLayoutOptions } from '../../_shared/pricing-layout-presets';

export default function TableSettings({ attributes, setAttributes }) {
  const { planLayout } = attributes;

  return (
    <PanelBody title={__('Layout', 'brandy-blocks')}>
      <SelectControl
        label={__('Plan layout', 'brandy-blocks')}
        value={planLayout || 'classic'}
        options={planLayoutOptions()}
        onChange={(value) => setAttributes({ planLayout: value })}
        help={__(
          'Applies to every plan; a single plan can override it in its own settings. Presets move each card’s own parts — parts nested inside a group are positioned by that group instead.',
          'brandy-blocks'
        )}
      />

      {/*
       * No column count here any more: the plans sit in a Group or a Columns
       * block, which already has layout controls an author knows. Spacing
       * between whatever the table holds is core's Block spacing control, over
       * in the Dimensions panel.
       */}
    </PanelBody>
  );
}
